import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
const apiUrl = process.env.REACT_APP_API_URL;

const SuspectPlatform = ({
  onNext,
  onSuspectContactSelected,
  onSuspectRadio,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  answer
}) => {
  const [suspectContacts, setSuspectContacts] = useState({
    contactValues: [],
    contactIds: [],
  });
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState([]);
  const [isYesSelected, setIsYesSelected] = useState(null);
  const [previousSelectedContacts, setPreviousSelectedContacts] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // State to track audio play status

  const audioRef = useRef(null);


  useEffect(() => {
    const storedSuspectCall = localStorage.getItem("suspectContact");
    if (storedSuspectCall) {
      const parsedCall = JSON.parse(storedSuspectCall);
      setSuspectContacts(parsedCall);
      onSuspectContactSelected(parsedCall);
      setPreviousSelectedContacts(parsedCall);
    }
  }, []);
  useEffect(() => {
    const storedSuspectCall = localStorage.getItem("radio");
    if (storedSuspectCall) {
      const parsedCall = JSON.parse(storedSuspectCall);
      setIsYesSelected(parsedCall);
      onSuspectRadio(parsedCall);
    }
  }, []);

  useEffect(() => {
    const fetchPlatFormData = async () => {
      try {
        const platFormResponse = await fetch(
          `${apiUrl}/v1/cy_ma_suspect_platforms_list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f653d914bc5",
              lac_token: botToken,
              app_ver: app_ver,
            }),
          }
        );

        if (!platFormResponse.ok) {
          throw new Error("Failed to fetch platform options");
        }

        const platFormData = await platFormResponse.json();
        setOptions(
          platFormData.resp.suspect_platforms_list.map((bank, index) => ({
            id: String.fromCharCode(65 + index),
            value: bank.splat_uniq,
            label: bank.splat_nm,
          }))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPlatFormData();
  }, [apiKey, botToken, vist_id, app_ver]);

  const handleOptionClick = (option, e) => {
    e.preventDefault();
    setShowOkButton(true);
    setError("");
    setSuspectContacts((prev) => {
      const contactValues = prev.contactValues.includes(option.value)
        ? prev.contactValues.filter((value) => value !== option.value)
        : [...prev.contactValues, option.value];
      const contactIds = prev.contactIds.includes(option.id)
        ? prev.contactIds.filter((id) => id !== option.id)
        : [...prev.contactIds, option.id];

      const updatedContacts = { contactValues, contactIds };
      localStorage.setItem("suspectContact", JSON.stringify(updatedContacts));
      return updatedContacts;
    });
  };

  const saveDataToAPI = async () => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_multichoice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f653d914bc5",
          qtion_num: "15",
          qtion_option: suspectContacts.contactIds,
          option_val: suspectContacts.contactValues,
          lac_token: botToken,
          app_ver: app_ver,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      const data = await response.json();
      // console.log(data)
      if (data.resp.error_code === "0") {
        onSuspectContactSelected(suspectContacts);
        onNext(16);
        onQuestion(17);
      } else {
        setError("Failed to push data to API");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save data, please try again.");
    }
  };

  const handleOkClick = async () => {
    onSuspectContactSelected(suspectContacts);
    if (
      JSON.stringify(suspectContacts) !== JSON.stringify(previousSelectedContacts)
    ) {
      
    if (suspectContacts.contactValues.length > 0) {
      await saveDataToAPI();
      setPreviousSelectedContacts(suspectContacts);
      
    } else {
      setError("Please select an option before proceeding.");
      // console.log("Please select an option before proceeding.");
      setShowOkButton(false);
    }
  }else{
    onNext(16);
    onQuestion(17);
  }
  };

  const handleRadioChange = (selection, e) => {
    e.preventDefault();
    localStorage.setItem("radio", JSON.stringify(selection));
    onSuspectRadio(selection);
    setIsYesSelected(selection);
    if (selection === "no") {
      onNext(16);
      onQuestion(17);
      setSuspectContacts({
        contactValues: [],
        contactIds: [],
      });
      localStorage.setItem("suspectContact", JSON.stringify({
        contactValues: [],
        contactIds: [],
      }));
      // localStorage.setItem("suspectContact", JSON.stringify("suspect"));
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault()
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause(); // Pause the audio
        setIsPlaying(false);
      } else {
        audioRef.current.play(); // Play the audio
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false); // Reset to show Play button when audio ends
  };

  //console.log(answer[15],isYesSelected)
  return (
    <div className="question" style={{ position: 'relative', zIndex: '9' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className="link">Any links shared?<span style={{ color: "red" }}>*</span></h2>
        <div style={{ display: "flex", marginLeft: '20px' }}>
          <button
            onClick={(e) => handleRadioChange("yes", e)}
            style={{
              marginRight: '10px',
              backgroundColor: isYesSelected === "yes" ? '#007bff' : 'initial',
              color: isYesSelected === "yes" ? 'white' : 'initial',
              border: '1px solid #007bff',
            }}
          >
            Yes
          </button>
          <button
            onClick={(e) => handleRadioChange("no", e)}
            style={{
              backgroundColor: isYesSelected === "no" ? '#007bff' : 'initial',
              color: isYesSelected === "no" ? 'white' : 'initial',
              border: '1px solid #007bff',
            }}
          >
            No
          </button>
          <button
                      onClick={toggleAudio}
                      className="audio-button"
                    >
                   {/* <FaPlay /> */}
                   {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>
                    <audio ref={audioRef} onEnded={handleAudioEnd}>
                      <source src="audio\anylink.mp3" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
        </div>
      </div>
      {(answer[15] && isYesSelected===null )&& (
            <p className="alert-box" style={{zIndex:'1000',width:'300px'}}>
              Please answer the current question before moving to the next.
            </p>
          )}
      {isYesSelected === "yes" && (
        <div>
           <div style={{display:'flex' }}>
          <h2>What is the platform(s) used by the fraudster</h2>
                    <button
                      onClick={toggleAudio}
                      className="audiobutton"
                    >
                   {/* <FaPlay /> */}
                   {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>
                    </div>
                    <audio ref={audioRef} onEnded={handleAudioEnd}>
                      <source src="audio\suspectplatform.mp3" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
          <div className="call-list" >
            {options.map((option) => (
              <button
                key={option.id}
                className={`option-button ${suspectContacts.contactValues.includes(option.value) ? "selected" : ""}`}
                onClick={(e) => handleOptionClick(option, e)}
                style={{ position: 'relative', zIndex: '1000' }}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: suspectContacts.contactValues.includes(option.value)
                        ? "#000"
                        : "#fff",
                      color: suspectContacts.contactValues.includes(option.value)
                        ? "#fff"
                        : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label">{option.label}</div>
                </div>
                {suspectContacts.contactValues.includes(option.value) && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
          </div>
          {showOkButton && (
            <div  style={{ position: 'relative', zIndex: '1000',marginTop:'-2px' }}>
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                OK
              </button>
            </div>
          )}
                    {(answer[15]) && (
            <p className="alert-box" style={{zIndex:'1000'}}>
              Please answer the current question before moving to the next.
            </p>
          )}
           {error && <div className="error-message"  style={{ position: 'relative', zIndex: '1000' }}>{error}</div>}
        </div>
      )}
    </div>
  );
};

export default SuspectPlatform;
